import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  SortingState,
  IntegratedSorting,
  EditingState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableEditRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';

import TimerIcon from '@material-ui/icons/Timer';
import LooksOneIcon from '@material-ui/icons/LooksOne';

import MoneyFormat from './format/MoneyFormat.js';
import SecondFormat from './format/SecondFormat.js';

import moment from 'moment';

import firebase from 'firebase/app';

require("firebase/firestore");
require("moment-duration-format");

function resolveDurationCondition(condition) {
  switch (condition.operator) {
    case "l":
      // return "less than";
      return "<";
    case "le":
      // return "less or equal to";
      return "<=";
    case "e":
      // return "equal to";
      return "=";
    case "ge":
      // return "greater or equal to";
      return ">=";
    case "g":
      // return "greater than";
      return ">";
    default:
      return "";
  }
}

const styles = theme => ({

});

const getRowId = row => row.id;
const columns = [
  { name: 'order', title: '#' },
  { name: 'condition', title: 'Conditions' },
  { name: 'weekday', title: 'Weekday Price' },
  { name: 'weekend', title: 'Weekend Price' },
  { name: 'buffer', title: 'Buffer Time' },
  { name: 'active', title: 'Active' },
];

const OrderTypeProvider = () => (
  <DataTypeProvider
    for={['order']}
    editorComponent={({ value, onValueChange }) => <div />}
  />
);

const ConditionTypeProvider = () => (
  <DataTypeProvider
    for={['condition']}
    formatterComponent={({ column, row, value }) =>
      <div>
        {
          row.conditions.map((condition, index) => {
            var label = null;
            var icon = null;
            if (condition.duration) {
              label = `${resolveDurationCondition(condition)} ${moment.duration(condition.duration, "seconds").format("h [h], m [m]")}`;
              icon = <TimerIcon />;
            } else if (condition.firstCome) {
              label = "First Come"
              icon = <LooksOneIcon />;
            }
            return (
              <Chip
                style={{ marginRight: "8px" }}
                key={index}
                icon={icon}
                label={label}
              />
            );
          })
        }
      </div>
    }
    editorComponent={({ value, onValueChange }) => <div />}
  />
);

const PriceTypeProvider = () => (
  <DataTypeProvider
    for={['weekday', 'weekend']}
    formatterComponent={({ column, row, value }) =>
      <MoneyFormat
        displayType='text'
        value={value}
        suffix={
          row.unit !== 0 ?
            " / " + moment.duration(row.unit, "second").format("h [hours], m [minutes]") :
            ""
        } />
    }
    editorComponent={({ column, row, value, onValueChange }) =>
      <Input
        fullWidth
        value={value}
        onChange={event => onValueChange(parseInt(event.target.value.replace(/\D/g, ''), 10) || 0)}
        inputComponent={MoneyFormat}
      />
    }
  />
);

const TimeTypeProvider = () => (
  <DataTypeProvider
    for={['buffer']}
    formatterComponent={({ value }) => moment.duration(value, "seconds").format("h [hours], m [minutes]")}
    editorComponent={({ column, row, value, onValueChange }) =>
      <Input
        fullWidth
        value={value}
        onChange={event => onValueChange(parseInt(event.target.value.replace(/\D/g, ''), 10) || 0)}
        inputComponent={SecondFormat}
      />
    }
  />
);

const ActiveTypeProvider = () => (
  <DataTypeProvider
    for={['active']}
    formatterComponent={({ value }) => <Icon>{value ? 'check' : 'close'}</Icon>}
    editorComponent={({ column, row, value, onValueChange }) =>
      <Checkbox
        checked={value}
        onChange={event => onValueChange(event.target.checked)}
      />
    }
  />
);

const commitChanges = ({ added, changed, deleted }) => {
  if (changed) {
    for (var rowId in changed) {
      var changedObj = changed[rowId];
      if (changedObj) {
        firebase.firestore().collection("priceRule").doc(rowId).update(changedObj);
      }
    }
  }
};

class PriceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rules: this.props.priceRule || [],

      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      rules: Array.from(nextProps.priceRule || []),
    });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <Paper>
        <Grid
          rows={this.state.rules}
          getRowId={getRowId}
          columns={columns}>

          <OrderTypeProvider />
          <ConditionTypeProvider />
          <PriceTypeProvider />
          <TimeTypeProvider />
          <ActiveTypeProvider />

          {/* State */}
          <EditingState onCommitChanges={commitChanges} />

          {/* Sorting */}
          <SortingState sorting={[{ columnName: 'order', direction: 'asc' }]} />
          <IntegratedSorting />

          <VirtualTable
            columnExtensions={[
              { columnName: 'order', width: 40 },
              { columnName: 'condition', width: this.state.width - 261 - 48 - 150 - 40 - 130 - 130 - 90 - 70 },
              { columnName: 'weekday', width: 130 },
              { columnName: 'weekend', width: 130 },
              { columnName: 'buffer', width: 90 },
              { columnName: 'active', width: 70 },
            ]}
            height={this.state.height - 112} />
          <TableHeaderRow />

          {/* Edit */}
          <TableEditRow />
          <TableEditColumn showEditCommand />

        </Grid>
      </Paper>
    );
  }
}

PriceTable.propTypes = {
  classes: PropTypes.object.isRequired,
  priceRule: PropTypes.array.isRequired,
};

export default withStyles(styles)(PriceTable);
